var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content",attrs:{"id":"app"}},[_c('router-view',{staticClass:"content"}),_c('br')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }